/**
 * Redux Store
 * Export store, hooks, provider, and slices
 */

// Store setup
export { default as store, type RootState, type AppDispatch } from "./store";
export { useAppDispatch, useAppSelector } from "./store.hooks";
export { default as StoreProvider } from "./provider";

// Store slices (actions and reducers)
export * from "./slices";
